const pageNameKey = "alarmProfilePopover";

export const alarmProfilePopoverEn = {
  [pageNameKey]: {
    edit: "Edit",
    duplicate: "Duplicate",
    delete: "Delete",
  },
};

export const alarmProfilePopoverPtBr = {
  [pageNameKey]: {
    edit: "Editar",
    duplicate: "Duplicar",
    delete: "Excluir",
  },
};

export const alarmProfilePopoverDe = {
  [pageNameKey]: {
    edit: "Bearbeiten",
    duplicate: "Duplizieren",
    delete: "Löschen",
  },
};

export const alarmProfilePopoverZhHans = {
  [pageNameKey]: {
    edit: "编辑",
    duplicate: "复制",
    delete: "删除",
  },
};

export const alarmProfilePopoverIt = {
  [pageNameKey]: {
    edit: "Modificare",
    duplicate: "Duplicato",
    delete: "Eliminare",
  },
};

export const alarmProfilePopoverEs = {
  [pageNameKey]: {
    edit: "Editar",
    duplicate: "Duplicar",
    delete: "Eliminar",
  },
};

export const alarmProfilePopoverNl = {
  [pageNameKey]: {
    delete: "Verwijderen",
    duplicate: "Dupliceren",
    edit: "Bewerken",
  },
};

export const alarmProfilePopoverTr = {
  [pageNameKey]: {
    delete: "Silmek",
    duplicate: "Kopyalamak",
    edit: "Düzenlemek",
  },
};
